// extracted by mini-css-extract-plugin
export default {"reports":"MedicalReports_reports__EaYeX","container":"MedicalReports_container__cRajA"};